import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import * as SettingsActions from '../../../state/actions/message-settings'
import ExistingPatientMessage from './ExistingPatientMessage'
import buildTextEditor from '../buildTextEditor'
import { logException } from '../../../services/sentry'

import './styles.css'

const ExistingPatientEmailEditor = buildTextEditor(ExistingPatientMessage)

const ExistingPatientMessageEditor = ({
  existingPatientMessage,
  pmsType,
  pmsVersion,
  updateMessageSetting,
}) => {
  const updateSetting = ({ body, subject, always_send }) => {
    const { id } = existingPatientMessage
    const changes = {
      body,
      subject,
      always_send,
    }

    return updateMessageSetting(id, changes).catch((err) => {
      logException(err)
    })
  }
  return (
    <div className="container">
      <h1>Patient Portal: Existing Patient Messaging</h1>
      <div>
        {existingPatientMessage && (
          <ExistingPatientEmailEditor
            key={existingPatientMessage.id}
            hasPlum={false}
            isEmail
            pmsType={pmsType}
            pmsVersion={pmsVersion}
            setting={existingPatientMessage}
            updateSetting={updateSetting}
          />
        )}
      </div>
    </div>
  )
}

ExistingPatientMessageEditor.propTypes = {
  existingPatientMessage: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }),
  pmsType: PropTypes.string,
  pmsVersion: PropTypes.number,
  updateMessageSetting: PropTypes.func,
}

const mapStateToProps = ({
  account: {
    auth: { pmsType, pmsVersion },
  },
}) => ({
  pmsType,
  pmsVersion,
})

const mapDispatchToProps = {
  updateMessageSetting: SettingsActions.updateMessageSetting,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExistingPatientMessageEditor)



// WEBPACK FOOTER //
// ./src/components/Settings/ExistingPatientMessageEditor/index.js